/*********************************************************/
/*** overwrites theme js | Latori GmbH www.latori.com ***/
/*********************************************************/

// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function(searchElement, fromIndex) {

      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      // 1. Let O be ? ToObject(this value).
      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If len is 0, return false.
      if (len === 0) {
        return false;
      }

      // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)
      var n = fromIndex | 0;

      // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      function sameValueZero(x, y) {
        return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
      }

      // 7. Repeat, while k < len
      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(searchElement, elementK) is true, return true.
        if (sameValueZero(o[k], searchElement)) {
          return true;
        }
        // c. Increase k by 1. 
        k++;
      }

      // 8. Return false
      return false;
    }
  });
}

// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function(predicate) {
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }
      var o = Object(this);
      var len = o.length >>> 0;
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var thisArg = arguments[1];
      var k = 0;
      while (k < len) {
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return k;
        }
        k++;
      }
      return -1;
    },
    configurable: true,
    writable: true
  });
}

// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function(predicate) {
     // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    },
    configurable: true,
    writable: true
  });
}

/******** Zip-modal ********/

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

$(document).ready(function () {

  var zipApproved = true;

  if (getCookie('zip')) {
    zipApproved = true;
  }

  let zip = getCookie("zip");
  let $body = $(document.body);
  const $modal = $('[data-modal-container]');
  const $modalInner = $modal.find('[data-modal-inner]');
  const $modalClose = $modal.find('[data-modal-close]');
  const $modalContent = $modal.find('[data-modal-content]');

  //Dev info

  var open = function () {
    $body.addClass('modal-loaded modal-visible scroll-lock');
    $modal.addClass('modal--plz modal--quickshop-full');
    let $content = $(`<div class="modal-plz-container">
                    <div class="modal-plz-content">
                      <div class="plz-image-holder">
                        <img src="//wildishausenzischexpress.com/cdn/shop/files/Logo_Zischexpress_RGB-1.png?v=1787117709">
                      </div>
                      <p class="plz-form-margin">Geben Sie bitte Ihre Postleitzahl ein, z.B. 27793</p>
                      <p class="line-item-property__field plz-form-margin">
                        <label for="zip-input"></label>
                        <input oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" type="number" class="form-field-input form-field-text" maxlength="5">
                      </p>
                      <button data-modal-submit class="button-primary plz-form-margin">LOS</button>
                    </div>
                  </div>`);
    $modalContent.append($content);
    $modal.find('[data-modal-submit]').on('click', function () {
      removeZipAlert();
      var zipInput = $content.find('input').val();

      if (zipMetafield.hasOwnProperty(zipInput)) {
        setCookie("zip", zipInput, 1);
        zipApproved = true;
        close();
      } else {
        if (zipInput.trim() != '') {
          zipAlert();
        }
      }
    });
  }

  var close = function () {
    $body.removeClass('modal-loaded modal-visible scroll-lock');
    $modal.removeClass('modal--plz');
    $modalContent.empty();
    $(window).off('keydown');
    $modal.find('[data-modal-submit]').off('click');
    disableCheckoutUnless(zipApproved);
  }

  var disableCheckoutUnless = function (zipApproved) {
    if (zipApproved != true) {
      $('[name="checkout"][type="submit"]').prop('disabled', true);
      $('[name="checkout"][type="submit"]').addClass('disabled');
    } else {
      $('[name="checkout"][type="submit"]').prop('disabled', false);
      $('[name="checkout"][type="submit"]').removeClass('disabled');
      $('.atc-button--checkout').removeClass('disabled');
    }
  }

  //disable checkout in the ajax cart modal
  $(document).ajaxSuccess(function() {
    if (zipApproved != true) {
      $('.atc-button--checkout').addClass('disabled');
      $('[href="/checkout"]').click(function (event) {
        event.preventDefault();
        open();
      });
    }
  });

  var zipAlert = function () {
    $('.modal-plz-content').append('<p class="zip-alert">Das tut uns leid. Wir liefern noch nicht an diese Postleitzahl.</p>');
  }

  var removeZipAlert = function () {
    $('.zip-alert').remove();
  }

  //Initial disable on refresh
  disableCheckoutUnless(zipApproved);

  $modalInner.on('click', function (event) {
    event.stopPropagation();
  });

  // $modal.on('click', function () {
  //   close();
  //   disableCheckoutUnless(zipApproved);
  // });

  // $(window).on('keydown', function (event) {
  //   if (event.key === 'Escape') {
  //     close();
  //     disableCheckoutUnless(zipApproved);
  //   }
  // });

  // $modalClose.on('click', function () {
  //   close();
  //   disableCheckoutUnless(zipApproved);
  // });

  if (!zip || zip === '' || zip === 'undefined') {
    //open();
  }
  
  $('.site-navigation .call-plz').on('click', function () {
    open();
  });

  /*
  $('.shopify-payment-button__button').on('click', function (e) {
    console.log('click');
    console.log('zipApproved: ' + zipApproved);
    if (zipApproved != true) {
      e.preventDefault();
      open();
    }
  });

  $('[data-testid="Checkout-button"]').click(function (e) {
    console.log('click');
    if (zipApproved != true) {
      e.preventDefault();
      open();
    }
  });*/

  $('[name="checkout"]').click(function (event) {
    if (zipApproved != true) {
      event.preventDefault();
      open();
    }
  });

  if ($('#product-content-tabbed').length) {

    $('#product-content-tabbed').find('.tab-headlines li').each(function() {
      $(this).click(function() {
        $('#product-content-tabbed').find('.tab-headlines li.active').removeClass('active');
        $(this).addClass('active');
        var target = $(this).data('target');
        $('[data-tab].show').removeClass('show');
        $('[data-tab="'+target+'"]').addClass('show');
      })
    })

  }

  var $shippingInfoLink = $('[data-product-shipping-time]');

  if($shippingInfoLink.length && $shippingInfoLink.attr('href') === '#') {
    var $shippingInfo = $('.product-shipping-time-extended');
    if ($shippingInfo.length) {
      $shippingInfo.hide();
      $shippingInfoLink.click(function(e) {
        e.preventDefault();
        $shippingInfo.toggleClass('show');
        if ($shippingInfo.hasClass('show')) {
          $shippingInfo.show("fast");
        } else {
          $shippingInfo.hide("fast");
        }
      });
    }
  }

  window.checkLeastShippment = function(callback) {
    var isCart = $('body.template-cart').length > 0;
    if (isCart) {
      $.getJSON( "/cart.json", function(cart) {
        var $cartMinimumMsg = $('.cart-no-minimun-order-quantity');
        var total_bottle_deposit = 0;
        cart.items.forEach(item => {
          if (item.product_type === "Pfand") {
            total_bottle_deposit = total_bottle_deposit + item.original_line_price;
          }
        });
        var total_price_without_bottle_deposit = cart.total_price - total_bottle_deposit;
        if (total_price_without_bottle_deposit <= 3000) {
          $('[name="checkout"][type="submit"]').prop('disabled', true);
          $('[name="checkout"][type="submit"]').addClass('disabled');
          if ($cartMinimumMsg.length) {
            $cartMinimumMsg.addClass('show');
          }
        } else {
          $('[name="checkout"][type="submit"]').prop('disabled', false);
          $('[name="checkout"][type="submit"]').removeClass('disabled');
          $('.atc-button--checkout').removeClass('disabled');
          if ($cartMinimumMsg.length) {
            $cartMinimumMsg.removeClass('show');
          }
        }
        if (callback && typeof(callback) == "function") {
          callback();
        }
      });
    } else {
      if (callback && typeof(callback) == "function") {
        callback();
      }
    }
  }

  window.checkLeastShippment();

  setTimeout( function() {
    var maxHeight = 0;
    $('.product-recently-viewed--section .productitem').each(function() {
      if ($(this).outerHeight() > maxHeight) {
        maxHeight = $(this).outerHeight();
      }
    });
    $('.product-recently-viewed--section .productitem').each(function() {
      if ($(this).parent('li').data('product-quickshop-url').includes('pfand')) {
        $(this).parent('li').remove();
      } else {
        $(this).height(maxHeight);
      }
      window.flickityRecently.resize();
    });
  }, 300);

  window.fetchPfandList = function(callback) {
    $.get( "/collections/pfand?view=json", function(products) {
      try {
        if (products) {
          window.pfandList = JSON.parse(products);
        }
      } catch (error) {
        console.log(error);
      }
      if (typeof callback === 'function') {
        callback();
      }
    });
  }

  var addPfandProducts = function(newProducts) {
    return new Promise(function(resolve, reject) {
      if (Object.keys(newProducts).length) {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: {
            items: newProducts
          },
          success: function(test) {
            return resolve();
          }
        });
      } else {
        return resolve();
      }
    });
  }

  var updatePfandProducts = function(updateItems) {
    return new Promise(function(resolve, reject) {
      if (Object.keys(updateItems).length) {
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          dataType: 'json',
          data: {
            updates: updateItems
          },
          success: function(test) {
            return resolve();
          }
        });
      } else {
        return resolve();
      }
    });
  }

    window.checkBottleDeposit = function() {
      $.get( "/cart?view=check-pfand", function(cart) {
        try {
          cart = JSON.parse(cart);

          console.log(cart);

          var pfandList = cart['pfand-list'];

          var hasProducts = cart.items.find(function(item) {
            return item.product_type != 'Pfand';
          });
          var hasBottleDepositItems = cart.items.find(function(item) {
            return item.product_type == 'Pfand';
          });

          if (!hasProducts && hasBottleDepositItems) {
            window.location = '/cart/clear';
            return;
          }

          var productItems = [];
          var bottleDepositItemsIs = [];
          var bottleDepositItemsShould = [];
          var removeItems = [];
          var addItems = []; 

          cart.items.forEach(function(item) {
            if (item.type == 'Pfand') {
              for (var index = 0; index < item.quantity; index++) {
                bottleDepositItemsIs.push(item);
              }
            } else {
              for (var index = 0; index < item.quantity; index++) {
                productItems.push(item);
              }
            }
          });

          // compare pfanditems in cart with products in cart if quantity is too low or too high or something is missing
          productItems.forEach(function(item) {
            if (item.pfand) {
              var i = bottleDepositItemsIs.findIndex(function(itm) {
                return item.pfand == itm.handle;
              });
              if (i > -1) {
                // remove from list for later check
                bottleDepositItemsIs.splice(i, 1);
              } else {
                if (pfandList.length) {
                  var pfandProduct = pfandList.find(function(product) {
                    return product.handle == item.pfand;
                  });
                  if(pfandProduct) {
                    addItems.push({ handle: pfandProduct.handle, variantId: pfandProduct.variantId });
                  }
                }
              }
            }
          });

          var updatesAdd = {};
          var newItemsAdd = [];

          // If pfand is missing, check if to raise up the quantity or add new ones
          if (addItems.length) {
            addItems.forEach(function(addItem) {
              // Is pfand already in cart, so just to raise up quantity?
              var foundLineItem = cart.items.find(function(item) {
                return (item.handle == addItem.handle) && (item.variantId == addItem.variantId);
              });
              var oldQuantity, newQuantity;
              // if found, get the key of the line item for update ajax
              var key = foundLineItem ? foundLineItem.key : addItem.variantId;
              if (typeof key == 'number' || !key.includes(':')) {
                // is not in cart, next step check if it is in the addlist and add it or create a new item in addlist
                var i = newItemsAdd.findIndex(function(newItemAdd) {
                  return newItemAdd.id == key;
                });
                if (i > -1) {
                  newItemsAdd[i].quantity = newItemsAdd[i].quantity + 1;
                } else {
                  newItemsAdd.push({
                    quantity: 1,
                    id: key
                  });
                }
              } else {
                // is in cart so just change the quantity
                oldQuantity = updatesAdd[key] ? updatesAdd[key] : foundLineItem.quantity;
                newQuantity = oldQuantity + 1
                updatesAdd[key] = newQuantity;
              }
            });
          };

          // Remove items if too much
          if (bottleDepositItemsIs.length) {
            bottleDepositItemsIs.forEach(function(item) {
              removeItems.push(item.key);
            });
          }

          var updatesRemove = {};

          if (removeItems.length) {
            removeItems.forEach(function(removeItem) {
              var foundLineItem = cart.items.find(function(item) {
                return item.key == removeItem;
              });
              var oldQuantity = updatesRemove[removeItem] ? updatesRemove[removeItem] : foundLineItem.quantity;
              var newQuantity = oldQuantity - 1
              updatesRemove[removeItem] = newQuantity;
            });
          }

          var updates = Object.assign({}, updatesAdd, updatesRemove);

          if (Object.keys(updates).length || Object.keys(newItemsAdd).length) {
            $('body').addClass('update-cart');
            Promise.all([updatePfandProducts(updates),addPfandProducts(newItemsAdd)]).then(function() {
              window.location.reload();
            });
          }
          
        } catch (error) {
        }
      });
    }

    /*jsn = JSON.parse(jsn);*/
    window.checkBottleDeposit();

    window.fetchPfandList(function() {
      // jsn.forEach(function(product) {
      //   if (window.pfandList && window.pfandList.length) {
      //     window.pfandList.forEach(function(pfand) {
      //       if (parseInt(product.pfand_nr) == parseInt(pfand.sku)) {
      //         console.log(pfand.handle, product.pfand_handle)
      //         if (pfand.handle != product.pfand_handle) {
      //           console.log('pfand handle: ' + encodeURIComponent(pfand.handle), 'product metafield: ' + encodeURIComponent(product.pfand_handle));
      //         }
      //       }
      //     });
      //   }
      // });
    });

    

});

/******** end Zip-modal ********/